import { LoaderCircle } from "lucide-react";

export const GateLoader = () => {
  return (
    <div className="w-5 h-5 flex items-center justify-center animate-spin text-sleap-purple-300">
      <LoaderCircle className="block" strokeWidth={3} />
    </div>
  );
};
